import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

import Spacer from 'core/spacer/Spacer';
import TextButton from 'core/buttons/TextButton';
import SettingItem from '../components/SettingItem';
import SectionTitle from 'core/section/SectionTitle';
import ChangePasswordForm from 'components/auth/ChangePasswordForm';

function SecuritySettingTab() {
  let [activeSetting, setActiveSetting] = useState(null);

  const handleEdit = (setting) => {
    setActiveSetting(setting);
  };

  let _settingItems = [
    {
      key: 'change-password',
      label: 'Change Password',
      content: <div></div>,
      contentSelected: (
        <Box>
          <Typography color="grey.600">
            Use this form to change your password. Once Changed, your new password will be in effect
            next time you login
          </Typography>
          <Spacer height="1.5rem" />
          <ChangePasswordForm setActiveSetting={setActiveSetting} />
        </Box>
      ),
      actions: (
        <TextButton onClick={() => handleEdit('change-password')} startIcon={<EditTwoToneIcon />}>
          Edit
        </TextButton>
      )
    }
  ];

  return (
    <Box sx={{ px: 4 }}>
      <SectionTitle>Security</SectionTitle>
      <Stack sx={{ mt: 2 }} divider={<Divider orientation="vertical" flexItem />}>
        {_settingItems.map((item) => (
          <SettingItem
            key={item.key}
            labelPrimary={item.label}
            content={activeSetting === item.key ? item.contentSelected : item.content}
            actions={item.actions}
            isActive={activeSetting === item.key}
          />
        ))}
      </Stack>
    </Box>
  );
}

export default SecuritySettingTab;
